<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Validation de commande</h1>
    </div>

    <div class="row">
      <!-- Colonne principale -->
      <div class="col-xl-8 col-md-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Informations de paiement</h3>
          </div>
          <div class="card-body">

            <ul class="tabs-menu nav">
              <li v-for="method in paymentMethods" :key="method.key" class="me-2">
                <a
                    href="javascript:void(0)"
                    class="payment-icon"
                    :class="{ active: selectedPayment === method.key }"
                    @click="selectedPayment = method.key"
                >
                  <i :class="method.icon"></i> {{ method.label }}
                </a>
              </li>
            </ul>
            <div class="tab-content mt-4">
              <div v-if="selectedPayment === 'CASH'">
                <p>Paiement en espèces à la livraison.</p>
              </div>
              <div v-else-if="selectedPayment === 'MOBILE_MONEY'">
                <p>Saisissez votre numéro Mobile Money pour recevoir une demande de paiement.</p>
                <input type="text" class="form-control" placeholder="Numéro Mobile Money">
              </div>
              <div v-else-if="selectedPayment === 'CARD'">
                <!-- Formulaire de carte bancaire -->
                <input type="text" class="form-control" placeholder="Numéro de carte">
              </div>
              <div v-else-if="selectedPayment === 'TRANSFER'">
                <p>Veuillez effectuer un virement aux coordonnées bancaires suivantes :</p>
                <ul>
                  <li><strong>Banque :</strong> Union Bank</li>
                  <li><strong>IBAN :</strong> 543218769</li>
                  <li><strong>Numéro de compte :</strong> 67542897653214</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Colonne droite -->
      <div class="col-xl-4 col-md-12">
        <!-- Adresse -->
        <div class="card mb-4">
          <div class="card-header">
            <h3 class="card-title">Adresse de livraison</h3>
          </div>
          <div class="card-body">
            <p><strong>Percy Kewshun</strong></p>
            <p>4231 Bingamon Branch Road</p>
            <p>Chicago, IL-60654</p>
            <p>UTC-5: Eastern Standard Time (EST)</p>
            <p>+125 254 3562</p>
          </div>
          <div class="card-footer">
            <button class="btn btn-primary w-100">Livrer à cette adresse</button>
          </div>
        </div>

        <!-- Résumé commande -->
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Votre commande</h3>
          </div>
          <div class="card-body">
            <!-- Exemple article -->
            <div v-for="item in cartItems" :key="item.id" class="d-flex mb-3">
              <img class="avatar-md br-7" :src="item.imageUrl || 'default.jpg'" :alt="item.name">

              <div class="ms-3 flex-grow-1">
                <h5 class="fw-semibold mb-1">{{ item.name }}</h5>
                <p class="text-muted small mb-0">Quantité : {{ item.quantity }}</p>
              </div>

              <div class="text-end">
                <span class="fw-bold">${{ item.referencePrice * item.quantity }}</span>
              </div>
            </div>

            <!-- Total -->
            <ul class="list-group border br-7 mt-5">
              <li class="list-group-item border-0">
                Sous-total
                <span class="h6 fw-bold mb-0 float-end">${{ cartTotal }}</span>
              </li>
              <li class="list-group-item border-0">
                Remise
                <span class="h6 fw-bold mb-0 float-end">0%</span>
              </li>
              <li class="list-group-item border-0">
                Livraison
                <span class="h6 fw-bold mb-0 float-end">Gratuite</span>
              </li>
              <li class="list-group-item border-0">
                Total
                <span class="h4 fw-bold mb-0 float-end">${{ cartTotal }}</span>
              </li>
            </ul>

          </div>
          <div class="card-footer text-end">
            <button class="btn btn-primary w-100" :disabled="isSubmitting" @click="submitSale">
              <i class="fe fe-check-circle me-2"></i> Confirmer la commande
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import {confirmAction} from "../../../helpers/helpers";

  export default {
    name: 'ShopCheckout',
    data() {
      return {
        paymentMethods: [
          { key: 'CASH', label: 'Espèces', icon: 'fa fa-money' },
          { key: 'MOBILE_MONEY', label: 'Mobile Money', icon: 'fa fa-mobile' },
          { key: 'CARD', label: 'Carte Bancaire', icon: 'fa fa-credit-card' },
          { key: 'TRANSFER', label: 'Virement Bancaire', icon: 'fa fa-university' }
        ],
        selectedPayment: 'CASH',
        sellerId: '687c23e31e05982ddc4c2bc4',  // à rendre dynamique plus tard
        isSubmitting: false
      };
    },
    computed: {
      ...mapGetters('cart', ['cartItems', 'cartTotal', 'isCartEmpty']),
    },

    methods: {
      ...mapActions('cart', ['clearCart']),
      async submitSale() {
        if (this.cartItems.length === 0) {
          swal("Erreur", "Votre panier est vide.", "error");
          return;
        }
        const { confirmed } = await confirmAction('validate');
        if (!confirmed) return;



        const payload = {
          reference: null,
          amount: parseFloat(this.cartTotal),
          paymentMethod: this.selectedPayment,
          sellerId: this.sellerId,
          products: this.cartItems.map(item => ({
            productCode: item.code,
            quantity: item.quantity,
            unitPrice: item.referencePrice
          }))
        };

        this.isSubmitting = true;

        this.$loading(true)

        this.$http.post('/sales', payload)
            .then(({ data }) => {
              this.$loading(false)
              swal("Succès", `Vente enregistrée. Référence : ${data}`, "success");
              this.clearCart();
              this.$router.push({ name: 'dashboard' });
            })
            .catch(error => {
              console.error(error);
              this.$loading(false)
              swal("Erreur", "Impossible de finaliser la commande.", "error");
            })
            .finally(() => {
              this.$loading(false)
              this.isSubmitting = false;
            });
      },
    },
    created() {
      this.$store.dispatch('cart/loadCart');
    },
  };
</script>

<style scoped>
.page-container {
  padding: 20px;
}
</style>
